import React from 'react';

const CtaCard = () => {
    return (
        <div className='cta-top-area'>
            <div className="cta-top">
                <p><strong>Save even more.</strong> Talk to our booking expert now.</p>
                <p className='online'><span>Agent is available now</span> 24/7 SUPPORT | NO HOLD TIME</p>
                <a href="tel:8882112111">(888) 211.2111</a>
            </div>
        </div>
    );
};

export default CtaCard;